import * as React from 'react';
import { Popconfirm } from 'antd';

export default function DeleteConfirmButton({
	title = 'Are you sure you want to delete?',
	onConfirm,
	onCancel,
	okText = 'Delete',
	cancelText = 'Cancel',
	placement = 'bottomLeft',
	disabled = false,
	buttonProps = {},
	children,
	...rest
}) {
	return (
		<Popconfirm
			title={title}
			onConfirm={onConfirm}
			onCancel={onCancel}
			okText={okText}
			cancelText={cancelText}
			placement={placement}
			disabled={disabled}
			{...rest}
		>
			{children}
		</Popconfirm>
	);
}
